<script>
import ViewTitle from '@/components/ViewTitle'
import FloatingLabelTextInput from '@/components/FloatingLabelTextInput'
import VueEditor from '@/components/vue2-editor/VueEditor'
import PhoneNotifPreview from '@/components/PhoneNotifPreview'
import LoadingBar from '@/components/LoadingBar'
import Button from '@/components/Button'
import FieldsValidator from '@/components/FieldsValidator'
import WideIconTile from '@/components/WideIconTile'
import FileUploadZone from '@/components/FileUploadZone'
import StoresServices from '@/services/stores'
import EnvironmentUtils from '@/utils/environmentUtils'
import StoreNotificationsServices from '@/services/storeNotifications'

const STEPS =
{
    NOTIFICATION_EDITOR: 0,
    NOTIFICATION_SENT: 1
}

export default
{
    name: 'store-notifications',

    created ()
    {
        const cityId = EnvironmentUtils.cityId

        StoresServices.fetchStores(cityId).then(async stores =>
        {
            await this.$store.commit('stores/updateStoreList', stores)
            await this.$store.dispatch('stores/fetchStoreNotificationQuota', { cityId, storeId: this.currentStore.id, token: this.$store.state.user.token })
        })
    },

    render ()
    {
        const n = this.currentStore.notificationQuota || {}

        return (
            <div id='store-notifications-view'>
                <view-title>Mes notifications</view-title>

                <div v-show={this.currentStep == STEPS.NOTIFICATION_EDITOR}>
                    <div class='row'>
                        <loading-bar progress={n.left / n.max} text={n.left + ' notifications restantes ce mois-ci'} />
                        <Button icon={require('@/assets/img/plus.svg')} type='light' class='upgrade-account-btn'
                            on-click={() => this.$router.push({path: 'upgrade', append: true})} />
                    </div>
                    <div class='edit-notif'>
                        <FieldsValidator ref='fieldsValidator'>
                        <floating-label-text-input placeholder='Le titre de votre notification' ref='notifTitle' v-model={this.notifTitle} />
                        <vue-editor placeholder='Le contenu de votre notification' show-toolbar={false} no-html={true}
                            ref='notifContent' v-model={this.notifContent} />
                        <file-upload-zone ref='fileUploadZone' v-model={this.notifPictures}
                            label='Ajouter une image' accept='.jpeg, .jpg, .png, .svg' max-file-count={1} />
                        </FieldsValidator>
                        <Button text='Envoyer la notification' on-click={this.sendNotification} class='send-btn' />
                        <phone-notif-preview title={this.notifTitle ? (this.currentStore.name + ' : ' + this.notifTitle) : 'Le titre de votre notifications'}
                            content={this.notifContent || 'Le contenu de votre notification appraîtra ici. Vous devez remplir les champs demandés'} />
                    </div>
                </div>
                <div v-show={this.currentStep == STEPS.NOTIFICATION_SENT}>
                {
                    this.currentStore &&
                    <div>
                        <div class='notif-sent-title'>Votre notification est envoyée ! 🎉</div>
                        <wide-icon-tile title={this.notifTitle} subtitle={this.notifContent} icon={this.currentStore.pictures[0]} />
                        <Button class='go-back-btn' text="Retourner au panel d'administration" type='secondary' on-click={() => this.$router.push('/edit')} />
                    </div>
                }
                </div>
            </div>
        )
    },

    data () 
    {
        return {
            currentStep: STEPS.NOTIFICATION_EDITOR,
            notifTitle: '',
            notifContent: '',
            notifPictures: []
        }
    },

    mounted ()
    {
    },

    computed:
    {
        currentStore ()
        {
            return this.$store.getters.stores.getStoreById(this.$route.params.id)
        }
    },

    methods:
    {
        async sendNotification (e, button)
        {
            if (!this.$refs.fieldsValidator.validate()) return

            const notif = this.createNotification()
            button.showSpinnerWhile(async () =>
            {
                await StoreNotificationsServices.sendNotification(notif, this.currentStore.id, EnvironmentUtils.cityId, this.$store.state.user.token)
                this.currentStep = STEPS.NOTIFICATION_SENT
            })
        },

        createNotification ()
        {
            return {
                title: this.notifTitle,
                content: this.notifContent,
                pictures: this.notifPictures,
                deliveredToSubscribersOnly: false,
            }
        }
    },

    components:
    {
        ViewTitle,
        FloatingLabelTextInput,
        VueEditor,
        PhoneNotifPreview,
        LoadingBar,
        Button,
        FieldsValidator,
        WideIconTile,
        FileUploadZone
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#store-notifications-view
{
    margin: 0 10px;
    margin-bottom: calc(var(--theme-horizontal-menu-height));
    display: flex;
    flex-direction: column;
    justify-content: center;

    .OnDesktop({
        margin-left: 5vw;
        margin-right: 5vw;
        margin-top: 4vw;
        border-left: var(--theme-vertical-menu-total-vertical-space) solid transparent;
    });

    .row
    {
        display: flex;
        flex-direction: row;
    }

    .loading-bar
    {
        height: 40px;
        border-radius: 12px;
        margin-right: 10px;
    }

    .upgrade-account-btn
    {
        width: 50px;
        border-radius: 8px;
        padding: 0;
    }

    .edit-notif
    {
        .floating-label-text-input
        {
            margin-top: 20px;
        }

        .vue-editor
        {
            margin-top: 10px;
        }

        .file-upload-zone
        {
            margin-top: 10px;
        }

        .send-btn
        {
            margin-top: 10px;
            width: -webkit-fill-available;
        }

        .phone-notif-preview
        {
            margin-top: 20px;
            height: 350px;
        }
    }

    .notif-sent-title
    {
        font-size: 20px;
        font-weight: 500;
        margin-bottom: 10px;
    }

    .go-back-btn
    {
        margin-top: 5px;
        width: -webkit-fill-available;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/StoreNotifications.vue